import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { H1 } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
var TitleAndCreate = function (_a) {
    var title = _a.title, buttonLabel = _a.buttonLabel, showForm = _a.showForm;
    return (React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
        React.createElement(H1, null,
            React.createElement(FormattedMessage, { id: title })),
        React.createElement(Button, { primary: true, onClick: showForm },
            React.createElement(FormattedMessage, { id: buttonLabel }))));
};
export default TitleAndCreate;
